import { createSelector } from 'reselect'

// PLOP_APPEND_PATTERN_ANCHOR

// facebook pages
export const facebookPagesSelector = createSelector(
  ({ socialAccounts }) => socialAccounts.facebookPages.results,
  results => results
)

export const facebookPagesIsLoadingSelector = createSelector(
  ({ socialAccounts }) => socialAccounts.facebookPages.isLoading,
  isLoading => isLoading
)

export const facebookPagesErrorSelector = createSelector(
  ({ socialAccounts }) => socialAccounts.facebookPages.error,
  error => error
)

export const facebookPagesWasLoadedSelector = createSelector(
  ({ socialAccounts }) => socialAccounts.facebookPages.wasLoaded,
  wasLoaded => wasLoaded
)

// accessible social(facebook, tiktok) pages which shared to user/partnership
export const accessibleSocialPagesSelector = createSelector(
  ({ socialAccounts }) => socialAccounts.accessibleSocialPages.results,
  results => results
)

export const accessibleSocialPagesIsLoadingSelector = createSelector(
  ({ socialAccounts }) => socialAccounts.accessibleSocialPages.isLoading,
  isLoading => isLoading
)

export const accessibleSocialPagesErrorSelector = createSelector(
  ({ socialAccounts }) => socialAccounts.accessibleSocialPages.error,
  error => error
)

export const accessibleSocialPagesWasLoadedSelector = createSelector(
  ({ socialAccounts }) => socialAccounts.accessibleSocialPages.wasLoaded,
  wasLoaded => wasLoaded
)

// add accessible social page
export const addAccessibleSocialPagesIsLoadingSelector = createSelector(
  ({ socialAccounts }) => socialAccounts.addAccessibleSocialPage.isLoading,
  isLoading => isLoading
)

export const addAccessibleSocialPagesErrorSelector = createSelector(
  ({ socialAccounts }) => socialAccounts.addAccessibleSocialPage.error,
  error => error
)

export const addAccessibleSocialPagesWasCreatedSelector = createSelector(
  ({ socialAccounts }) => socialAccounts.addAccessibleSocialPage.wasCreated,
  wasCreated => wasCreated
)

// delete accessible social page
export const deleteAccessibleSocialPagesIdSelector = createSelector(
  ({ socialAccounts }) => socialAccounts.deleteAccessibleSocialPage.id,
  isLoading => isLoading
)
export const deleteAccessibleSocialPagesIsLoadingSelector = createSelector(
  ({ socialAccounts }) => socialAccounts.deleteAccessibleSocialPage.isLoading,
  isLoading => isLoading
)

// facebook page access tokens
export const facebookPageAccessTokensSelector = createSelector(
  ({ socialAccounts }) => socialAccounts.facebookPageAccessTokens,
  facebookPageAccessTokens => facebookPageAccessTokens
)

// Create facebook page access request
export const createFacebookPageAccessRequestSelector = createSelector(
  ({ socialAccounts }) => socialAccounts.createFacebookPageAccessRequest.results,
  results => results
)

export const createFacebookPageAccessRequestIsLoadingSelector = createSelector(
  ({ socialAccounts }) => socialAccounts.createFacebookPageAccessRequest.isLoading,
  isLoading => isLoading
)

export const createFacebookPageAccessRequestErrorSelector = createSelector(
  ({ socialAccounts }) => socialAccounts.createFacebookPageAccessRequest.error,
  error => error
)

export const createFacebookPageAccessRequestWasCreatedSelector = createSelector(
  ({ socialAccounts }) => socialAccounts.createFacebookPageAccessRequest.wasCreated,
  wasCreated => wasCreated
)

// instagram accounts
export const instagramAccountsSelector = createSelector(
  ({ socialAccounts }) => socialAccounts.instagramAccounts,
  instagramAccounts => instagramAccounts
)

// backed instagram accounts
export const backedInstagramAccountsSelector = createSelector(
  ({ socialAccounts }) => socialAccounts.backedInstagramAccounts,
  backedInstagramAccounts => backedInstagramAccounts
)

// Get facebook pages lead gen forms
export const facebookPagesLeadGenFormsSelector = createSelector(
  ({ socialAccounts }) => socialAccounts.facebookPagesLeadGenForms.results,
  results => results
)

export const getFacebookPagesLeadGenFormsIsLoadingSelector = createSelector(
  ({ socialAccounts }) => socialAccounts.facebookPagesLeadGenForms.isLoading,
  isLoading => isLoading
)

export const getFacebookPagesLeadGenFormsErrorSelector = createSelector(
  ({ socialAccounts }) => socialAccounts.facebookPagesLeadGenForms.error,
  error => error
)

export const facebookPagesLeadGenFormsWasLoadedSelector = createSelector(
  ({ socialAccounts }) => socialAccounts.facebookPagesLeadGenForms.wasLoaded,
  wasLoaded => wasLoaded
)

// Get facebook debug tokens
export const getFacebookDebugTokensSelector = createSelector(
  ({ socialAccounts }) => socialAccounts.facebookDebugTokens.results,
  results => results
)

export const getFacebookDebugTokensIsLoadingSelector = createSelector(
  ({ socialAccounts }) => socialAccounts.facebookDebugTokens.isLoading,
  isLoading => isLoading
)

export const getFacebookDebugTokensErrorSelector = createSelector(
  ({ socialAccounts }) => socialAccounts.facebookDebugTokens.error,
  error => error
)

export const getFacebookDebugTokensWasLoadedSelector = createSelector(
  ({ socialAccounts }) => socialAccounts.facebookDebugTokens.wasLoaded,
  wasLoaded => wasLoaded
)
